import NumberInput, { NumberInputProps as InputNumberProps } from '../NumberInput';

/**
 * The `InputNumber` component is used to enter a numerical value.
 * @see https://rsuitejs.com/components/number-input
 * @deprecated Use `NumberInput` instead.
 */
const InputNumber = NumberInput;

// export types
export type { InputNumberProps };

// export components
export { InputNumber };
export default InputNumber;
